<div [ngClass]="{'dettaglio-date-container-acl': acl == 'eell'}" class="dettaglio-date-container">

    <h1 class="colorSearch" mat-dialog-title>INVIA A PROTOCOLLO REGIONALE {{this.nomeEvento}} </h1>

    <div class="file-upload-container">
        <div>Sicuro che vuoi inviare a protocollo regionale la segnalazione?</div>
        <br>
        <mat-dialog-actions align="end">
            <button mat-stroked-button color='accent' class='persBtn' (click)=sendToProtocol() [disabled]="this.isCompleted">
                <p class='cont'>Invia a protocollo</p>
            </button>
        </mat-dialog-actions>
    </div>

    <mat-dialog-actions align="end">
      <button mat-stroked-button color='accent' class='persBtn' mat-dialog-close>
        <p class='cont'>CHIUDI</p>
      </button>
    </mat-dialog-actions>

</div>
